<template>
  <div id="help-shop-fovorite" class="help">
    <call />
    <!-- header -->
    <header>
      <header-app :rate="counterBlock" :canMobileOrder="isMobileOrderEnabled()"></header-app>
      <span><menu-app></menu-app></span>
      <div class="ssm-overlay ssm-toggle-nav"></div>
    </header>

    <!-- main -->
    <main>
      <section>
        <div class="l-main l-main--bg-border l-main--bg-border--pink">
          <div class="l-main__head">
            <a
              href="#"
              class="l-main__head--control l-main__head--control--back"
            >
              <!-- <img src="images/icon/icon-back-white.svg?v=2" alt="" /> -->
            </a>
            <div class="l-main__head--title">ヘルプ</div>
            <a @click="$router.go(-1)" class="l-main__head--control l-main__head--control--close">
              <img src="/assets/images/icon/icon-close-black.svg" alt="" />
            </a>
          </div>
          <div class="l-main__body">
            <div class="l-check-cart">
              <div class="l-check-cart__head">
                <div class="l-check-cart__title text-left">お気に入り登録</div>
                <p>ショップニュース、イベント、クーポンは、お気に入りとして登録する事ができます。</p>
                <div class="help-card">
                  <div class="l-check-cart__title text-left">お気に入り登録方法</div>
                  <p class="l-check-cart__title text-left">1.ハートマークをタップする</p>
                  <p>ショップニュースやイベント、クーポンのハートマークをタップすると、お気に入りに登録されます。</p>
                  <img class="" src="/assets/images/help-fovorite-1.png" alt="" />
                </div>
                <div class="help-card">
                  <div class="l-check-cart__title text-left">お気に入りを確認する</div>
                  <p class="l-check-cart__title text-left">1.お気に入りアイコンをタップ</p>
                  <p>下部ナビゲーションの「お気に入り」をタップします。</p>
                  <p>※実際の画面と異なる可能性があります。下部ナビゲーションに該当のアイコンがない場合、「menu」をタップし、「お気に入り」アイコンをタップしてください</p>
                  <img class="help-m-b-16" src="/assets/images/help-fovorite-2.png?t=20220520" alt="" />
                  <p class="l-check-cart__title text-left">2.お気に入りを確認する</p>
                  <p>タブをタップすると、ショップニュース、イベント、クーポンのお気に入りを確認する事が出来ます。</p>
                  <img class="" src="/assets/images/help-fovorite-3.png" alt="" />
                </div>
                <div class="help-card">
                  <div class="l-check-cart__title text-left">お気に入りの解除方法</div>
                  <p class="l-check-cart__title text-left">1.ハートマークをタップする</p>
                  <p>お気に入り登録した、ショップニュースやイベント、クーポンのハートマークをタップすると解除できます。</p>
                  <img class="" src="/assets/images/help-fovorite-4.png" alt="" />
                </div>
              </div>
            </div>
          </div>
          <div v-on:click="backPagePrevious" class="c-btn-check l-shop-deal__box-back box-center">
            <div class="l-shop-deal__box-back--icon"><img src="/assets/images/icon/icon-back.svg" alt=""></div>
            <div class="l-shop-deal__box-back--title">戻る</div>
            <div class="l-shop-deal__box-back--icon"></div>
          </div>
        </div>
      </section>
    </main>
  </div>
</template>

<script>
import "core-js/stable";
import "regenerator-runtime/runtime";
import Vue from "vue";
import Header from "../components/Header.vue";
import MenuApp from "../components/Menu.vue";
import { Common } from "../common/common.js";
import { Tenant } from "../plugin/mixin.js";


export default Vue.extend({
  name: "HelpLoginDetail",
  components: {
    "header-app": Header,
    "menu-app": MenuApp,
  },
  mixins: [Tenant],
  data() {
    return {
      loading: false,
    };
  },
  created() {
    this.init();
  },
  mounted() {
    Common.initDom();
  },
  methods: {
    async init() {
      Common.vueInitFunc(this);
      this.loading = false;
    },
  },
});
</script>